<script lang="ts">
export default {
  name: 'KkLoading',
}
</script>

<script lang="ts" setup>
import { computed } from 'vue'

export interface Props {
  minHeight?: string
}

const props = withDefaults(defineProps<Props>(), {
  minHeight: '240px'
})

const styles = computed<Record<string, string>>(() => {
  return { minHeight: props.minHeight }
})
</script>

<template>
  <div class="loading" :style="styles">
    <svg class="loading__spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="loading__circle" fill="none" stroke="#E9446A" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30" />
    </svg>
  </div>
</template>

<style lang="scss" scoped>
@import "../../../../../stylesheets/biz_spa/foundation/_var.scss";
@import "../../../../../stylesheets/biz_spa/foundation/_mixin.scss";
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 20px;
  &__spinner {
    animation: rotation 1.35s linear infinite;
  }
  &__circle {
    stroke-dasharray: 180;
    stroke-dashoffset: 0;
    transform-origin: center;
    animation: turn 1.35s ease-in-out infinite;
  }
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes turn {
  0% {
    stroke-dashoffset: 180;
    transform: rotate(90deg);
  }
  50% {
    stroke-dashoffset: 45;
    transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: 180;
    transform: rotate(450deg);
  }
}
</style>
